import React, { useState } from "react";
import { Table, Button, message } from "antd";
import { ITopType } from "@/types/ScmTypes";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBox } from "@/components/YhBox";
import { DetailType } from "@/types/ScmEnums";
import { components } from "@/components/YHEditTable/editTable";
import { useDictModel } from "@/views/base/dict/dictModel";
import { globalPrompt } from "@/components/message";
export const ThreeServiceTable: React.FC<ITopType> = ({ mode, IFormRef }) => {
  const {
    popupMode, setPopupMode,
    SBcode, setSBcode,
    setThreeServiceModal,
    detailAddForm, detailEditForm,
    detailSBItemAddList, setDetailSBItemAddList,
    detailSBItemAddDataRowKeys, setDetailSBItemAddDataRowKeys,
    detailSBItemAddDataRow, setDetailSBItemAddDataRow,
    detailSBItemEditList, setDetailSBItemEditList,
    detailSBItemEditDataRowKeys, setDetailSBItemEditDataRowKeys,
    detailSBItemEditDataRow, setDetailSBItemEditDataRow,
    detailSBItemLookList, setDetailSBItemLookList,
    detailSBItemDetailList
  } = useMaintenanceDetailsModel();
  const { getTreeNodeName } = useDictModel();

  const typeForm: any = {
    add: { ...detailAddForm },
    edit: detailEditForm,
  };
  const typeSBItemList = {
    "add": [...detailSBItemAddList],
    "edit": [...detailSBItemEditList],
    "look": [...detailSBItemLookList],
  }
  const columns: any = [
    {
      title: "序号",
      width: 40,
      align: "center",
      render: (t: any, r: any, i: any) => i + 1,
    },
    {
      title: "三包品牌",
      dataIndex: "threeGuaranteesBrand",
      width: 100,
      render: (text: any, record: any) =>

      (<span
        style={{ color: record.id ? '#3e67f4' : '', cursor: record.id ? 'pointer' : '' }}
        onClick={() => {
          if (record.id) {
            setSBcode(record.id)
            setPopupMode("edit");
            setThreeServiceModal(true)
          }
        }}
      >{getTreeNodeName(text)}</span>)

      ,
    },
    {
      title: "索赔单号",
      dataIndex: "claimNumber",
      width: 100,
    },
    {
      title: "故障处理",
      dataIndex: "faultHandle",
      width: 200,
    },
    {
      title: "材料费",
      dataIndex: "materialAmount",
      width: 100,
    },
    {
      title: "出库金额",
      dataIndex: "outboundAmount",
      width: 100,
    },
    {
      title: "工时费",
      dataIndex: "hourlyWage",
      width: 100,
    },
    {
      title: "外出费",
      dataIndex: "travelExpenses",
      width: 100,
    },
    {
      title: "餐补费",
      dataIndex: "mealSupplement",
      width: 100,
    },
    {
      title: "其他费用",
      dataIndex: "otherAmount",
      width: 100,
    },
    {
      title: "索赔总额",
      dataIndex: "totalClaim",
      width: 100,
    },
    {
      title: "结算单号",
      dataIndex: "statementNumber",
      width: 100,
    },
    {
      title: "三包工时费汇总",
      dataIndex: "totalHourlyWage",
      width: 160,
    },
  ];
  const action = <>
    {<>
      <YhAuth resCode={ResourceAuthEnum.M_ED_ADD_I}>
        <Button
          className="mr-5"
          type="primary"
          shape="round"
          onClick={async () => {
            IFormRef.current?.validateFields().then(async () => {
              setPopupMode("add");
              setThreeServiceModal(true);
            })
          }}
          disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
        >添加三包信息</Button>
      </YhAuth>
      <YhAuth resCode={ResourceAuthEnum.M_ED_DEL_I}>
        <Button
          className="mr-5"
          type="primary"
          shape="round"
          onClick={() => {
            const selectedRowKeys = mode === DetailType.add ? detailSBItemAddDataRowKeys : detailSBItemEditDataRowKeys;
            const selectedRows = mode === DetailType.add ? detailSBItemAddDataRow : detailSBItemEditDataRow;
            if (selectedRowKeys.length === 0) {
              message.warning("请先选择要删除的三包信息");
              return;
            }
            globalPrompt("modal", {
              title: "删除三包信息",
              type: "warning",
              text: `确定要删除选中的 ${selectedRowKeys.length} 条三包信息吗？`,
              okText: "确定",
              cancelText: "取消",
              onOk: () => {
                detailSBItemDetailList(mode);
              },
              onCancel: () => { }
            });
          }}
          disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
        >删除三包信息</Button>
      </YhAuth>
    </>}
  </>;
  //设置维修项目选中的行和数据
  const setTypeSBItemDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
    if (mode === DetailType.add) {
      setDetailSBItemAddDataRowKeys(selectedRowKeys)
    } else if (mode === DetailType.edit) {
      setDetailSBItemEditDataRowKeys(selectedRowKeys)
    }
  }
  const setTypeSBItemDetailDataRow = async (selectedRows: any[], mode: string) => {
    if (mode === DetailType.add) {
      setDetailSBItemAddDataRow(selectedRows)
    } else if (mode === DetailType.edit) {
      setDetailSBItemEditDataRow(selectedRows)
    }
  }

  return (
    <YhBox title='三包信息' rightChildren={action} style={{ marginBottom: "75px", paddingBottom: "25px" }}>
      <Table
        bordered
        rowKey={record => record.tempId || record.id}
        rowClassName='editable-row yh-edit-table-tr'
        rowSelection={
          mode === "look" ? undefined : {
            selectedRowKeys: mode === DetailType.add ? detailSBItemAddDataRowKeys : detailSBItemEditDataRowKeys, //记录选中
            onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
              setTypeSBItemDetailDataRowKeysAndRow(selectedRowKeys, mode)
              setTypeSBItemDetailDataRow(selectedRows, mode)
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
              setTypeSBItemDetailDataRow(selectedRows, mode)
            }
          }}
        columns={columns}
        dataSource={typeSBItemList[mode]}
        components={components}
        pagination={false}
        scroll={{ x: 'max-content', y: 250 }}
      />
    </YhBox>
  );
};
